import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TCTransport } from '@macs-frontend/features/company-management/team-cost/team-cost.types';
import { InvoiceItemTransport } from '@macs-frontend/features/shared/models/invoice-item-transport.model';

@Component({
  selector: 'md-transport',
  templateUrl: './transport.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportComponent implements OnInit, OnChanges {
  @Input() transports: (TCTransport | InvoiceItemTransport)[] = [];

  @Input() currencySign = '';

  constructor(readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  getTransportBillableRowTotal(transport: TCTransport | InvoiceItemTransport): number {
    if (transport.billableTotalAmount) {
      return transport.billableTotalAmount;
    }

    return transport.totalBillablePrice * transport.qty;
  }
}
